import './scss/index.scss'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import i18n from './i18n'
import App from './App.vue'
import setup from '@/setup.js'
import 'virtual:svg-icons-register'
import popper from 'vue3-popper'
import { plugin as InputFacade } from 'vue-input-facade'

const app = i18n(createApp(App))

app.component('popper', popper)
app.use(InputFacade, {
  name: 'mask',
  tokens: {
    '#': { pattern: /\d/ },
    'X': { pattern: /[0-9A-Z]/i },
    'A': { pattern: /[a-z]/i, transform: v => v.toLocaleUpperCase() },
    'a': { pattern: /[a-z]/i },
    'N': { pattern: /[0-9a-z]/i, transform: v => v.toLocaleUpperCase()  },
    'S': { pattern: /[a-z]/i }
  }
})
app.use(createPinia())
setup()
app.mount('#app')
